/* global document */

import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { useComponentWillMount } from 'common/helpers/hooks';

import APIError from '../apiError/APIError';

const Layout = (props) => {
  const { children, title, description } = props;

  const settings = useSelector((state) => state.setting.data);
  const { companyName } = settings;

  let seoTitle = companyName;
  if (title) {
    seoTitle = `${title} | ${companyName}`;
  }

  useComponentWillMount(() => {
    const c7Content = document.getElementById('c7-content');
    c7Content.removeAttribute('style');
    c7Content.style.minHeight = '50vh';
    const c7CheckoutContent = document.getElementById('c7-checkout-content');
    if (c7CheckoutContent) {
      c7CheckoutContent.parentNode.removeChild(c7CheckoutContent);
    }
  });

  useEffect(() => {
    const c7Content = document.getElementById('c7-content');
    c7Content.style.minHeight = 0;
  }, []);

  return (
    <>
      <Helmet>
        <title>{seoTitle}</title>
        {description && <meta name="description" content={description} />}
      </Helmet>
      <APIError position="layout" />
      {children}
    </>
  );
};

export default Layout;
